import React from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaClock } from 'react-icons/fa';
import '../Contact/Reach.css';

const Reach = () => {
  return (
    <div className="contact-container">
      <h2 className="contact-title">Reach Out</h2>
      <div className="contact-items">
        <div className="contact-item">
          <FaMapMarkerAlt className="contact-icon" />
          <h3>Our Office Address</h3>
          <p>
            New Delhi,<br />
            India
          </p>
        </div>
        <div className="contact-item">
          <FaEnvelope className="contact-icon" />
          <h3>General Enquiries</h3>
          <p>
            <a href="mailto:websupport@justdial.com" className="contact-link">
              info@xyz.com
            </a>
          </p>
        </div>
        <div className="contact-item">
          <FaPhoneAlt className="contact-icon" />
          <h3>Call Us</h3>
          <p>
            <a href="tel:+9100000000" className="contact-link">
              +91-0000000000
            </a>
          </p>
        </div>
        <div className="contact-item">
          <FaClock className="contact-icon" />
          <h3>Our Timings</h3>
          <p>Mon - Sun: 8:00 AM - 09:00 PM</p>
          <p>Sat: 2:00 PM - 04:00 PM</p>
        </div>
      </div>
    </div>
  );
};

export default Reach;
